(() => {
  'use strict';
  if (window.BiovardiVisualDepth) { window.BiovardiVisualDepth.scan(); return; }
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  const elements = new Map();
  const visible = new Set();
  let frame = 0;
  const enabled = () => !reduce.matches && !document.hidden;
  const canMove = el => el.closest('[data-bv-motion]')?.dataset.bvMotion === 'true';
  function reset(el) { ['--depth-y','--tilt-x','--tilt-y'].forEach(p => el.style.removeProperty(p)); }
  function render() {
    frame = 0;
    if (!enabled()) return;
    visible.forEach(el => {
      if (!el.isConnected || !canMove(el)) return;
      const r=el.getBoundingClientRect();
      const p=(innerHeight/2-r.top-r.height/2)/innerHeight;
      el.style.setProperty('--depth-y',`${Math.max(-7,Math.min(7,p*13)).toFixed(2)}px`);
    });
  }
  function schedule() { if (!frame && enabled()) frame=requestAnimationFrame(render); }
  const observer = new IntersectionObserver(entries => {
    entries.forEach(e => e.isIntersecting ? visible.add(e.target) : visible.delete(e.target));
    schedule();
  },{rootMargin:'80px'});
  function scan() {
    elements.forEach((cleanup,el) => {
      if (!el.isConnected) { cleanup(); observer.unobserve(el);visible.delete(el);elements.delete(el); }
    });
    document.querySelectorAll('.bv-visual-home [data-bv-depth], .bv-visual-home .bv-ritual-products').forEach(el => {
      if (elements.has(el)) return;
      const move=e=>{
        if (!enabled() || !fine.matches || !canMove(el))return;
        const r=el.getBoundingClientRect();
        el.style.setProperty('--tilt-y',`${((e.clientX-r.left)/r.width-.5)*7}deg`);
        el.style.setProperty('--tilt-x',`${-((e.clientY-r.top)/r.height-.5)*5}deg`);
      };
      const leave=()=>{el.style.removeProperty('--tilt-x');el.style.removeProperty('--tilt-y');};
      if (el.matches('.bv-portrait')) {el.addEventListener('pointermove',move);el.addEventListener('pointerleave',leave);}
      elements.set(el,()=>{el.removeEventListener('pointermove',move);el.removeEventListener('pointerleave',leave);});
      observer.observe(el);
    });
    schedule();
  }
  function sync(){
    if (!enabled()){cancelAnimationFrame(frame);frame=0;elements.forEach((_,el)=>reset(el));} else schedule();
  }
  addEventListener('scroll',schedule,{passive:true});
  addEventListener('resize',schedule,{passive:true});
  document.addEventListener('visibilitychange',sync);
  reduce.addEventListener('change',sync);
  document.addEventListener('shopify:section:load',scan);
  document.addEventListener('shopify:section:unload',()=>queueMicrotask(scan));
  window.BiovardiVisualDepth={scan};
  scan();
})();
